import React from "react";

const EditLeave = ({
    openEditModal,
    setOpenEditModal,
    selectedLeave,
    setSelectedLeave,
    handleUpdateLeave,
    handleCancelLeave,
}) => {
    if (!selectedLeave) return null;

    const handleInputChange = (field, value) => {
        setSelectedLeave((prev) => ({ ...prev, [field]: value }));
    };

    return (
        <>
            {/* Modal Backdrop */}
            {openEditModal && (
                <div
                    className="modal fade show"
                    style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content" style={{
                            borderRadius: "12px",
                            maxHeight: 'none'
                        }}>
                            <div className="modal-header">
                                <h5 className="modal-title">Edit Leave Request</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setOpenEditModal(false)}
                                ></button>
                            </div>

                            <div className="modal-body">
                                {/* Leave Type */}
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Leave Type</label>
                                    <select
                                        className="form-select"
                                        value={selectedLeave.leaveType || ""}
                                        onChange={(e) =>
                                            handleInputChange("leaveType", e.target.value)
                                        }
                                    >
                                        <option value="SICK_LEAVE">Sick Leave</option>
                                        <option value="CASUAL_LEAVE">Casual Leave</option>
                                        <option value="EARNED_LEAVE">Earned Leave</option>
                                    </select>
                                </div>

                                {/* Date From */}
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Date From</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ background: "none" }}
                                        value={selectedLeave.startDate?.slice(0, 10) || ""}
                                        onChange={(e) =>
                                            handleInputChange("startDate", e.target.value)
                                        }
                                    />
                                </div>

                                {/* Date To */}
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Date To</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ background: "none" }}
                                        value={selectedLeave.endDate?.slice(0, 10) || ""}
                                        onChange={(e) =>
                                            handleInputChange("endDate", e.target.value)
                                        }
                                    />
                                </div>

                                {/* Reason */}
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Reason</label>
                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        value={selectedLeave.reason || ""}
                                        onChange={(e) =>
                                            handleInputChange("reason", e.target.value)
                                        }
                                    ></textarea>
                                </div>
                            </div>

                            <div className="modal-footer d-flex justify-content-between">
                                <button
                                    type="button"
                                    className="btn btn-outline-danger"
                                    disabled={selectedLeave.leaveStatus !== "PENDING"}
                                    onClick={() => handleCancelLeave(selectedLeave.leaveId)}
                                >
                                    Cancel Leave
                                </button>

                                <div>
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary me-2"
                                        onClick={() => setOpenEditModal(false)}
                                    >
                                        Close
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => handleUpdateLeave(selectedLeave)}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default EditLeave;
